import { auto } from '@popperjs/core';
import React, { useState } from 'react';
import { toAbsoluteUrl } from '../../../helpers';
import { toast } from 'react-toastify';
import { createOne } from '../../../../app/services/common_requests';
import { useQueryResponse } from '../../../../app/pages/hotel-management/hotel-list/core/QueryResponseProvider';
import { useIntl } from 'react-intl';
import { ImageCropper } from '../../components/ImageCropper';
import { ImageDimensionHint } from '../../components/ImageDimensionHint';

interface ImageUploaderProps {
  onImageUpload: (image: File | null) => void;
  onImageAdded: (image: { url: string; _id: string }) => void;
  uploadEndpoint: string;
  hotelId?: string;
}

const ImageUploader: React.FC<ImageUploaderProps> = ({ onImageUpload, onImageAdded, uploadEndpoint, hotelId }) => {
  const [image, setImage] = useState<string | null>(null);
  const [pendingFile, setPendingFile] = useState<File | null>(null);
  const {refetchData} = useQueryResponse()
  const intl=useIntl()

  const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      // Ouvre le cropper au lieu d'uploader directement
      setPendingFile(file);
    }
  };

  const handleCropped = async (croppedFile: File, previewUrl: string) => {
    setPendingFile(null);
    setImage(previewUrl);
    const formData = new FormData();
    formData.append('image', croppedFile);
    if (hotelId) {
      formData.append('hotel', hotelId);
    }
    try {
      await createOne(formData, uploadEndpoint).then((response) => {
        if (response?.payload?.code === 2021) {
          onImageUpload(croppedFile);
          onImageAdded({ url: response?.data.url, _id: response?.data._id });
          refetchData()
          toast.success(
            intl.formatMessage({
              id: 'ADMIN.COMMON.SUCCESS.IMAGE_UPDATED_SUCCESSFULLY',
            }),
            {
              position: 'top-right',
              autoClose: 4000,
            }
          )
          refetchData()
        } else {
          toast.error(
            intl.formatMessage({
              id: 'ADMIN.COMMON.ERROR.IMAGE_UPDATED',
            }),
            {
              position: 'top-right',
              autoClose: 4000,
            }
          )
        }
      })
    } catch (error) {
      toast.error(
        intl.formatMessage({
          id: 'ADMIN.COMMON.ERROR.IMAGE',
        }),
        {
          position: 'top-right',
          autoClose: 4000,
        }
      )
    }
  };

  return (
    <>
      <div className='image-container-dashed'>
        <div className='upload-input-container'>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className='inpute'
          />
        </div>
        {image ? (
          <img src={image} alt="Preview" className='preview-image-uploader' />
        ) : (
          <div className='image-container-placeholder'>
            <img src={toAbsoluteUrl('/media/icons/upload-image.png')}  alt="uploadimage"/>
            <span>{intl.formatMessage({
              id: 'COMMON.ADD',
            })}</span>
          </div>
        )}
        <ImageDimensionHint entity='hotelGalleryLarge' />
      </div>

      {pendingFile && (
        <ImageCropper
          file={pendingFile}
          aspect={2}
          title="Recadrer l'image de la galerie"
          onCropped={handleCropped}
          onCancel={() => setPendingFile(null)}
        />
      )}
    </>
  );
};

export default ImageUploader;
